import { SLIDE } from '../constants'
import { convertStyle, convertSettings, convertParallaxImageStyle, getDiff } from '../api/converter'
import arrayMove from 'array-move'
import store from '../store'
import { menuActions } from './index'
import { defaultCaptionState, defaultButtonCaption, defaultBoxCaption, defaultShapeCaption, defaultImageCaption } from '../../defaulState'
import * as boxUtils from '../api/boxUtils'
import { convertDimension } from '../api/converter'
import _ from 'lodash'
import { getCaptionWidth } from '../../Utils/utils'
import { getRightPropertyValue } from '../../Utils/helpers'

const captionOuterlineSize = 0;
const getIsMobile = () => store.getState().menuReducer.viewType == 'mobile';

const slideActions = {

    initSlideSettings() {
        let slide = JSON.parse(sessionStorage.getItem('editing-slide'))

        if (slide && slide.backupData) {
            delete slide.backupData
            // console.log('backupData');
            return {
                type: SLIDE.INIT_SLIDE_SETTINGS,
                payload: slide
            }
        }

        let onClickCash, linkTypeCash;
        let diffW = null;
        let diffH = null;
        let diff = getDiff(slide.widgetData.originalWidth, slide.widgetData.originalHeight)
        slide = convertSettings(slide, slide.widgetData.originalWidth, slide.widgetData.originalHeight)
        // originalWidth и originalHeight - текущие размеры виджета на странице
        slide.parallaxImage = convertParallaxImageStyle(slide.parallaxImage, slide.widgetData.originalWidth, slide.widgetData.originalHeight)

        slide.captions.map((caption, index) => {

            if (typeof caption.onClick == 'string') {
                onClickCash = {
                    value: caption.onClick
                };
                switch (caption.onClick.value) {
                    case 'doNothing':
                        onClickCash.label = 'Do nothing'
                        break;
                    case 'navigateTo':
                        onClickCash.label = 'Navigate to'
                        break;
                }
                caption.onClick = onClickCash
            }

            if (typeof caption.linkType == 'string') {
                linkTypeCash = {
                    value: caption.linkType
                }
                switch (caption.linkType.value) {
                    case 'wix':
                        linkTypeCash.label = 'Wix'
                        break;

                    case 'anchor':
                        linkTypeCash.label = 'Anchor'
                        break;

                    case 'link':
                        linkTypeCash.label = 'Link'
                        break;
                }
                caption.linkType = linkTypeCash
            }
        })
        // сохраняю копию для сравнения перед закрытием окна
        const slideClone = _.cloneDeep(slide);
        delete slideClone.actions
        delete slideClone.actionIndex
        // delete slideClone.hasParallax
        // delete slideClone.parallaxImage
        delete slideClone.widgetData
        sessionStorage.setItem('editing-slide-saved-state', JSON.stringify(slideClone))
        slide.widgetData.globalDiff = diff;
        return {
            type: SLIDE.INIT_SLIDE_SETTINGS,
            payload: slide
        }
    },

    updateSlideSettings(slide) {
        //  slide = slide === undefined ? JSON.parse(sessionStorage.getItem('editing-slide')) : slide
        return {
            type: SLIDE.UPDATE_SLIDE_SETTINGS,
            payload: slide
        }
    },

    errorOff(newVal) {
        return {
            type: SLIDE.ERROR_OFF,
            payload: newVal
        }
    },

    //==================!Caption!===========================

    addCaption(isMobile) {
        let caption = _.cloneDeep(defaultCaptionState);
        const widgetDimasion = store.getState().slideReducer.widgetData
        const diff = getDiff(widgetDimasion.originalWidth, widgetDimasion.originalHeight)
        caption = convertDimension(caption, diff)
        caption.id = `id-${Date.now() + parseInt(Math.random() * 1000)}`
        return {
            type: SLIDE.ADD_CAPTION,
            payload: { caption, isMobile }
        }
    },
    addButton(isMobile) {

        let button = _.cloneDeep(defaultButtonCaption);
        const widgetDimasion = store.getState().slideReducer.widgetData
        const diff = getDiff(widgetDimasion.originalWidth, widgetDimasion.originalHeight)
        button = convertDimension(button, diff)
        button.id = `id-${Date.now() + parseInt(Math.random() * 1000)}`

        return {
            type: SLIDE.ADD_CAPTION,
            payload: { caption: button, isMobile }
        }
    },

    addBox(isMobile) {
        let box = _.cloneDeep(defaultBoxCaption);
        const widgetDimasion = store.getState().slideReducer.widgetData
        const diff = getDiff(widgetDimasion.originalWidth, widgetDimasion.originalHeight)
        box = convertDimension(box, diff)
        box.id = `id-${Date.now() + parseInt(Math.random() * 1000)}`
        return {
            type: SLIDE.ADD_CAPTION,
            payload: { caption: box, isMobile }
        }
    },

    addShape(isMobile) {
        const isFreePlan = !store.getState().slideReducer.showSmartPremiumSettings
        let shape = _.cloneDeep(defaultShapeCaption);
        if (isFreePlan) {
            shape.backgroundColor.type = 'color'
        }
        const widgetDimasion = store.getState().slideReducer.widgetData
        const diff = getDiff(widgetDimasion.originalWidth, widgetDimasion.originalHeight)
        shape = convertDimension(shape, diff)
        shape.id = `id-${Date.now() + parseInt(Math.random() * 1000)}`
        return {
            type: SLIDE.ADD_CAPTION,
            payload: { caption: shape, isMobile }
        }
    },

    addImage(data, isMobile) {
        const isFreePlan = !store.getState().slideReducer.showSmartPremiumSettings
        let image = _.cloneDeep(defaultImageCaption);
        if (isFreePlan) {
            image.backgroundColor.type = 'color'
        }
        const widgetDimasion = store.getState().slideReducer.widgetData
        const diff = getDiff(widgetDimasion.originalWidth, widgetDimasion.originalHeight)
        image = convertDimension(image, diff)
        image.id = `id-${Date.now() + parseInt(Math.random() * 1000)}`
        image.imageURL = `https://static.wixstatic.com/media/${data.relativeUri}`
        image.relativeUri = data.relativeUri
        image.originalDimensions = { height: data.height, width: data.width }

        const ratio = data.width / data.height

        const dimensions = { height: 200, width: 200 * ratio }

        if (dimensions.width > 200 && data.width != 0 && data.height != 0) {
            dimensions.width = 200
            dimensions.height = 200 / ratio
        }

        image.width = dimensions.width
        image.height = dimensions.height

        return {
            type: SLIDE.ADD_CAPTION,
            payload: { caption: image, isMobile }
        }
    },

    setImageCaptionCrop(index, value, isMobile = getIsMobile()) {
        return {
            type: SLIDE.SET_IMAGE_CAPTION_CROP,
            payload: { index, value, isMobile }
        }
    },

    pasteCaptions(isMobile) {
        let captions = store.getState().menuReducer.copyCaptions
        if (captions.length === 0 && sessionStorage.getItem('copy-captions-text-slider')) {
            const parsedCaptions = JSON.parse(sessionStorage.getItem('copy-captions-text-slider'))
            captions = parsedCaptions
        }
        return {
            type: SLIDE.PASTE_CAPTIONS,
            payload: { captions, isMobile },
        }
    },

    addCaptionInBox(captionIndex, boxId, position) {
        return {
            type: SLIDE.ADD_CAPTION_IN_BOX,
            payload: { captionIndex, boxId, position }
        }
    },


    addPoint(boxIndex, pointIndex, nextPointIndex, position) {
        return {
            type: SLIDE.ADD_POINT,
            payload: { boxIndex, pointIndex, nextPointIndex, position },
        }
    },

    changeCaptionCubeHeight(captionIndex, newVal, isMobile = getIsMobile()) {
        return {
            type: SLIDE.CHANGE_CAPTION_CUBE_HEIGHT,
            payload: { captionIndex, newVal, isMobile }
        }
    },

    deleteCaption(captionsArray) {
        const captionSelectedArray = captionsArray || store.getState().menuReducer.captionSelectedArray
        const viewType = store.getState().menuReducer.viewType

        if (viewType === 'mobile') {
            // return {
            //     // type: SLIDE.CHANGE_CAPTION_MOBILE_SHOW,
            //     // payload: { captionSelectedArray, newVal: false }
            //     type: SLIDE.TOGGLE_CAPTION_HIDE,
            //     payload: { captionSelectedArray, newVal: true, isMobile: true }
            // }
        } else {
            return {
                type: SLIDE.DELETE_CAPTION,
                payload: { captionSelectedArray }
            }
        }
    },
    deleteCaptionByCaptionIndex(index) {
        const viewType = store.getState().menuReducer.viewType

        // if (viewType === 'mobile') {
        //     return {
        //         type: SLIDE.CHANGE_CAPTION_MOBILE_SHOW,
        //         payload: { index, newVal: false }
        //     }
        // } else {
        return {
            type: SLIDE.DELETE_CAPTION_BY_CAPTION_INDEX,
            payload: { index }
        }
        // }
    },

    deletePoint(captionIndex, pointIndex) {
        return {
            type: SLIDE.DELETE_POINT,
            payload: { captionIndex, pointIndex }
        }
    },


    changeCaptionPosition(captionIndex, lastX, lastY, viewType, boxId) {
        const mobileViewScale = store.getState().menuReducer.mobileViewScale // 100 - 200
        return {
            type: SLIDE.CHANGE_CAPTION_POSITION,
            payload: { captionIndex, lastX, lastY, viewType, boxId, mobileViewScale }
        }
    },

    changeCaptionRelativePosition(captionIndex, lastX, lastY, viewType) {
        const mobileViewScale = store.getState().menuReducer.mobileViewScale // 100 - 200
        return {
            type: SLIDE.CHANGE_CAPTION_RELATIVE_POSITION,
            payload: { captionIndex, lastX, lastY, viewType, mobileViewScale }
        }
    },

    changeAllSelectedCaptionsPosition(lastX, lastY) {
        const captionSelectedArray = store.getState().menuReducer.captionSelectedArray;
        const viewType = store.getState().menuReducer.viewType;
        const captions = store.getState().slideReducer.captions;
        const widgetData = store.getState().slideReducer.widgetData
        const isMobile = viewType === 'mobile'
        const desktopDims = { width: widgetData.width, height: widgetData.height }
        const mobileDims = { width: widgetData.mobileWidth, height: widgetData.mobileHeight }
        let positionProperty, widthProperty, heightProperty, x, y;
        let newPositions = new Map();
        let newPosition;

        switch (viewType) {
            case 'desktop':
                positionProperty = 'position';
                widthProperty = 'width';
                heightProperty = 'height';
                break;

            case 'mobile':
                positionProperty = 'mobilePosition';
                widthProperty = 'mobileWidth';
                heightProperty = 'mobileHeight';
                break;
        }
        captionSelectedArray.map((index) => {
            // debugger;
            newPosition = captions[index][positionProperty]

            if (newPosition == undefined) {
                newPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', true, captions[index])
            }

            if (captions[index].boxId === '') {
                x = 'x';
                y = 'y';
            } else {
                x = 'relativeX';
                y = 'relativeY';
            }

            // newPosition[x] = lastX
            newPosition[x] += lastX
            // newPosition[y] = lastY
            newPosition[y] += lastY


            // if (newPosition[x] + captions[index][widthProperty] > widgetDimasion[widthProperty]) {
            //     newPosition[x] = widgetDimasion[widthProperty] - captions[index][widthProperty]
            // } else if (newPosition[x] < 0) {
            //     newPosition[x] = 0
            // }
            // if (newPosition[y] + captions[index][heightProperty] > widgetDimasion[heightProperty]) {
            //     newPosition[y] = widgetDimasion[heightProperty] - captions[index][heightProperty]
            // } else if (newPosition[y] < 0) {
            //     newPosition[y] = 0
            // }
            newPositions.set(index, newPosition)
        })


        return {
            type: SLIDE.CHANGE_SOME_CAPTIONS_POSITION,
            payload: { captionSelectedArray, newPositions, viewType }
        }
    },

    changeBoxPointPosition(boxIndex, pointIndex, newPoint) {
        return {
            type: SLIDE.CHANGE_BOX_POINT_POSITION,
            payload: { boxIndex, pointIndex, newPoint }
        }
    },

    changeHtmlTag(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_HTML_TAG,
            payload: { captionSelectedArray, newVal }
        }
    },

    toggleButtonAnimation(captionSelectedArray, newValue) {
        return {
            type: SLIDE.TOGGLE_BUTTON_ANIMATION,
            payload: { captionSelectedArray, value: newValue }
        }
    },
    toggleButtonIconAnimation(captionSelectedArray, newValue) {
        return {
            type: SLIDE.TOGGLE_BUTTON_ICON_ANIMATION,
            payload: { captionSelectedArray, value: newValue }
        }
    },

    toggleButtonIcon(captionSelectedArray, newValue) {
        return {
            type: SLIDE.TOGGLE_BUTTON_ICON,
            payload: { captionSelectedArray, value: newValue }
        }
    },
    changeButtonIcon(captionSelectedArray, newValue, isCustom) {
        return {
            type: SLIDE.CHANGE_BUTTON_ICON,
            payload: { captionSelectedArray, value: newValue, isCustom }
        }
    },
    changeButtonIconLocation(captionSelectedArray, newValue) {
        return {
            type: SLIDE.CHANGE_BUTTON_ICON_LOCATION,
            payload: { captionSelectedArray, value: newValue }
        }
    },
    changeButtonIconSize(captionSelectedArray, newValue, isMobile) {
        return {
            type: SLIDE.CHANGE_BUTTON_ICON_SIZE,
            payload: { captionSelectedArray, value: newValue, isMobile }
        }
    },
    changeButtonIconMargin(captionSelectedArray, newValue, isMobile) {
        return {
            type: SLIDE.CHANGE_BUTTON_ICON_MARGIN,
            payload: { captionSelectedArray, value: newValue, isMobile }
        }
    },
    changeButtonIconAnimation(captionSelectedArray, newValue) {
        return {
            type: SLIDE.CHANGE_BUTTON_ICON_ANIMATION,
            payload: { captionSelectedArray, value: newValue }
        }
    },

    setTextStrokeSize(captionSelectedArray, value, isMobile = getIsMobile()) {
        return {
            type: SLIDE.SET_TEXT_STROKE_SIZE,
            payload: { captionSelectedArray, value, isMobile }
        }
    },
    setTextStrokeColor(captionSelectedArray, value) {
        return {
            type: SLIDE.SET_TEXT_STROKE_COLOR,
            payload: { captionSelectedArray, value }
        }
    },
    changeStripesColor(captionSelectedArray, value) {
        return {
            type: SLIDE.CHANGE_CAPTION_STRIPES_COLOR,
            payload: { captionSelectedArray, value }
        }
    },
    changeStripesSpeed(captionSelectedArray, value) {
        return {
            type: SLIDE.CHANGE_CAPTION_STRIPES_SPEED,
            payload: { captionSelectedArray, value }
        }
    },


    changeCaptionDimesions(captionIndex) {
        // changeCaptionDimesions(captionIndex, newVal = {}, viewType, mobileViewScale = 1) {
        const viewType = store.getState().menuReducer.viewType;
        const mobileViewScale = store.getState().menuReducer.mobileViewScale / 100;
        const newVal = {}
        // везде берём размер из DOM, но если он не пришёл, как в случае с ресайзом, то ищем тут
        const isImage = store.getState().slideReducer.captions[captionIndex].type === 'image'
        const captionInDom = isImage ? document.getElementById(`caption-${captionIndex}`).parentElement.getBoundingClientRect() : document.getElementById(`caption-${captionIndex}`).getBoundingClientRect()
        newVal.width = captionInDom.width / mobileViewScale;
        newVal.height = captionInDom.height / mobileViewScale;

        return {
            type: SLIDE.CHANGE_CAPTION_DIMESIONS,
            payload: { captionIndex, newVal, viewType, mobileViewScale }
        }
    },

    changeTextCaptionDimesions(captionIndex) {
        // changeTextCaptionDimesions(captionIndex, newVal, viewType, mobileViewScale = 1) {
        const viewType = store.getState().menuReducer.viewType;
        const mobileViewScale = store.getState().menuReducer.mobileViewScale / 100;
        const newVal = {}
        const captionInDom = document.getElementById(`caption-${captionIndex}`).getBoundingClientRect()

        newVal.width = captionInDom.width / mobileViewScale;
        newVal.height = captionInDom.height / mobileViewScale;
        return {
            type: SLIDE.CHANGE_CAPTION_DIMESIONS,
            payload: { captionIndex, newVal, viewType }
        }
    },

    changeArrayCaptionsDimesions(selectedArray) {
        const selectedCaptions = new Map()
        const viewType = store.getState().menuReducer.viewType;
        const captions = store.getState().slideReducer.captions
        const mobileViewScale = store.getState().menuReducer.mobileViewScale / 100;

        selectedArray.map(captionIndex => {
            // проходимся только по текстовым капчам, т.к. только у них массовое изменение параметров может привести к изменению размеров
            if (captions[captionIndex].type === 'text' || captions[captionIndex].type === 'button') {
                const newVal = {}
                const captionInDom = document.getElementById(`caption-${captionIndex}`).getBoundingClientRect()
                newVal.width = captionInDom.width / mobileViewScale;
                newVal.height = captionInDom.height / mobileViewScale;
                selectedCaptions.set(captionIndex, newVal)
            }
        })
        return {
            type: SLIDE.CHANGE_ARRAY_CAPTIONS_DIMESIONS,
            payload: { selectedCaptions, viewType }
        }
    },

    // не используется
    changeBoxEditingDimesions() {
        const captionIndex = store.getState().menuReducer.editingCaptionIndex
        const viewType = store.getState().menuReducer.viewType
        const newVal = {
            width: store.getState().slideReducer.captions[captionIndex].width,
            height: store.getState().slideReducer.captions[captionIndex].height
        }
        return {
            type: SLIDE.CHANGE_BOX_EDITING_DIMANSIONS,
            payload: { captionIndex, newVal, viewType }
        }
    },

    setCaptionSize(captionIndex, newVal) {
        // новые размеры в формате newVal = {[propName]: Math.round(value)}
        return {
            type: SLIDE.SET_CAPTION_SIZE,
            payload: { captionIndex, newVal }
        }
    },
    applyCaptionsSizesInFirstLoad(sizesObj) {
        // в формате {[caption.index]: {width: caption.width, height: caption.height}}
        // вызывается только для десктопа и только сразу после открытия редактора
        return {
            type: SLIDE.APPLY_CAPTIONS_SIZES_IN_FIRST_LOAD,
            payload: sizesObj
        }
    },

    applyStyle(caption, index) {
        return {
            type: SLIDE.APPLY_STYLE,
            payload: { style: caption, index }
        }
    },

    //========================!Slide!===========================


    changeSlideName(slideName) {
        return {
            type: SLIDE.CHANGE_SLIDE_NAME,
            payload: slideName
        }
    },

    changeSlideBackground(color) {
        return {
            type: SLIDE.CHANGE_SLIDE_BACKGROUND,
            payload: color
        }
    },

    changeBackgroundHasShadow(newVal) {
        newVal = newVal === undefined ? !store.getState().slideReducer.hasBackgroundShadow : newVal;
        return {
            type: SLIDE.CHANGE_SLIDE_HAS_BACKGROUND_SHADOW,
            payload: newVal
        }
    },

    changeBackgroundShadow(newVal) {
        return {
            type: SLIDE.CHANGE_SLIDE_BACKGROUND_SHADOW,
            payload: newVal
        }
    },

    //====================!Link!================================


    changeLinkOnClick(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_LINK_ON_CLICK,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeLinkType(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_LINK_TYPE,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeLink(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_LINK,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeIsHover(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_IS_HOVER,
            payload: { captionSelectedArray, newVal }
        }
    },

    //================!!Border!!==================================

    changeBorderWidth(captionSelectedArray, newVal) {
        const viewType = store.getState().menuReducer.viewType;
        // const captions = store.getState().slideReducer.captions;
        // captionSelectedArray.map(captionIndex => {
        //     const { width, height } = document.getElementById(`caption-${captionIndex}`).getBoundingClientRect();
        //     if (captions[captionIndex].type != 'box') {
        //         store.dispatch(slideActions.changeCaptionDimesions(captionIndex, { width, height }, viewType))
        //     }
        // })
        return {
            type: SLIDE.CHANGE_BORDER_WIDTH,
            payload: { captionSelectedArray, newVal, viewType }
        }
    },

    changeBorderRadius(captionSelectedArray, newVal) {
        const viewType = store.getState().menuReducer.viewType;
        return {
            type: SLIDE.CHANGE_BORDER_RADIUS,
            payload: { captionSelectedArray, newVal, viewType }
        }
    },

    changeBorderColor(captionSelectedArray, newVal) {
        // const captions = store.getState().slideReducer.captions;
        // captionSelectedArray.map(index=>{
        //     const caption = captions[index]
        //     if(caption.type === 'box'){
        //         newVal = boxUtils.getOpacityForBoxBorder(caption.backgroundColor, newVal)
        //     }
        // })
        return {
            type: SLIDE.CHANGE_BORDER_COLOR,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeBorderColorHover(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_BORDER_COLOR_HOVER,
            payload: { captionSelectedArray, newVal }
        }
    },

    //======================!!!Background!!!===========================

    changeBackgroundColor(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_BACKGROUND_COLOR,
            payload: { captionSelectedArray, newVal }
        }
    },
    changeOverlayColor(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_OVERLAY_COLOR,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeCaptionImage(index, newVal) {
        return {
            type: SLIDE.CAPTION_IMAGE_CHANGE,
            payload: { index, value: newVal }
        }
    },

    changeBlur(captionSelectedArray, newVal) {
        return {
            type: SLIDE.SET_BLUR,
            payload: { captionSelectedArray, newVal }
        }
    },

    toggleGlassBlur(captionSelectedArray, newVal) {
        return {
            type: SLIDE.TOGGLE_GLASS_BLUR,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeCaptionEffectType(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_CAPTION_EFFECT,
            payload: { captionSelectedArray, newVal }
        }
    },

    setInvertEffect(captionSelectedArray, newVal) {
        return {
            type: SLIDE.SET_INVERT_EFFECT,
            payload: { captionSelectedArray, newVal }
        }
    },

    setGrayscaleEffect(captionSelectedArray, newVal) {
        return {
            type: SLIDE.SET_GRAYSCALE_EFFECT,
            payload: { captionSelectedArray, newVal }
        }
    },

    setGlassEffect(captionSelectedArray, newVal) {
        return {
            type: SLIDE.SET_GLASS_EFFECT,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeBackgroundColorHover(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_BACKGROUND_COLOR_HOVER,
            payload: { captionSelectedArray, newVal }
        }
    },

    changePadding(captionSelectedArray, newVal) {
        const viewType = store.getState().menuReducer.viewType;
        // const captions = store.getState().slideReducer.captions;
        // captionSelectedArray.map(captionIndex => {
        //     const { width, height } = document.getElementById(`caption-${captionIndex}`).getBoundingClientRect();
        //     if (captions[captionIndex].type != 'box') {
        //         store.dispatch(slideActions.changeCaptionDimesions(captionIndex, { width, height }, viewType))
        //     }
        // })
        return {
            type: SLIDE.CHANGE_PADDING,
            payload: { captionSelectedArray, newVal, viewType }
        }
    },

    changeSVGSrc(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_SVG_SRC,
            payload: { captionSelectedArray, newVal }
        }
    },

    //=======================!!!Animation!!!=============================

    changeHoverAnimation(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_HOVER_ANIMATION,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeAnimationIn(captionSelectedArray, newVal, editingCaptionIndex) {
        return {
            type: SLIDE.CHANGE_ANIMATION_IN,
            payload: { captionSelectedArray, newVal, editingCaptionIndex }
        }
    },

    changeAnimationOut(captionSelectedArray, newVal, editingCaptionIndex) {
        return {
            type: SLIDE.CHANGE_ANIMATION_OUT,
            payload: { captionSelectedArray, newVal, editingCaptionIndex }
        }
    },

    changeAnimationDelayIn(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_ANIMATION_DELAY_IN,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeAnimationDelayOut(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_ANIMATION_DELAY_OUT,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeAnimationInMode(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_ANIMATION_IN_MODE,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeAnimationOutMode(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_ANIMATION_OUT_MODE,
            payload: { captionSelectedArray, newVal }
        }
    },
    changeAnimationLoop(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_ANIMATION_LOOP,
            payload: { captionSelectedArray, newVal }
        }
    },


    //=====================!!!Typing Animation======================


    addLineForTypingAnimations(captionIndex) {
        return {
            type: SLIDE.ADD_LINE,
            payload: captionIndex
        }
    },

    changeLineText(editingCaptionIndex, lineIndex, newText) {
        lineIndex = lineIndex === undefined ? 0 : lineIndex

        // const viewType = store.getState().menuReducer.viewType;
        // const mobileViewScale = store.getState().menuReducer.mobileViewScale / 100;
        // const { width, height } = document.getElementById(`caption-${editingCaptionIndex}`).getBoundingClientRect();
        // store.dispatch(slideActions.changeCaptionDimesions(editingCaptionIndex, { width, height }, viewType))
        // setTimeout(() => {

        store.dispatch(slideActions.changeCaptionDimesions(editingCaptionIndex))
        // },100)
        return {
            type: SLIDE.CHANGE_LINE_TEXT,
            payload: { editingCaptionIndex, lineIndex, newText }
        }
    },


    deleteLineForTypingAnimations(editingCaptionIndex, lineIndex) {
        return {
            type: SLIDE.DELETE_LINE,
            payload: { editingCaptionIndex, lineIndex }
        }
    },

    changePauseBetweenLines(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_PAUSE_BETWEEN_LINES,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeSelectedLine(editingCaptionIndex, newVal) {
        return {
            type: SLIDE.CHANGE_SELECTED_LINE,
            payload: { editingCaptionIndex, newVal }
        }
    },


    //=======================!!!Text!!!=============================


    changeCaptionText(captionIndex, newText) {
        // const viewType = store.getState().menuReducer.viewType;
        // const { width, height } = document.getElementById(`caption-${captionIndex}`).getBoundingClientRect();
        // store.dispatch(slideActions.changeCaptionDimesions(captionIndex, { width, height }, viewType))
        store.dispatch(slideActions.changeCaptionDimesions(captionIndex))

        return {
            type: SLIDE.CHANGE_CAPTION_TEXT,
            payload: { captionIndex, newText }
        }
    },

    changeTextAlign(captionSelectedArray, newAlign) {
        return {
            type: SLIDE.CHANGE_TEXT_ALIGN,
            payload: { captionSelectedArray, newAlign }
        }
    },


    changeCaptionFont(captionSelectedArray, newFont) {

        return {
            type: SLIDE.CHANGE_CAPTION_FONT,
            payload: { captionSelectedArray, newFont }
        }
    },

    changeCaptionFontColor(captionSelectedArray, newColor) {
        return {
            type: SLIDE.CHANGE_CAPTION_FONT_COLOR,
            payload: { captionSelectedArray, newColor }
        }
    },

    changeCaptionFontColorHover(captionSelectedArray, newColor) {
        return {
            type: SLIDE.CHANGE_CAPTION_FONT_COLOR_HOVER,
            payload: { captionSelectedArray, newColor }
        }
    },

    changeCaptionFontSize(captionSelectedArray, newVal) {
        const viewType = store.getState().menuReducer.viewType;
        let diffVal = null;
        if (captionSelectedArray.length > 1) {
            const editedCaptionIndex = store.getState().menuReducer.editingCaptionIndex;
            const editetCaptionCurrentFontSize = store.getState().slideReducer.captions[editedCaptionIndex].fontSize;
            diffVal = newVal - editetCaptionCurrentFontSize
        }
        // captionSelectedArray.map(captionIndex => {
        //     store.dispatch(slideActions.changeCaptionDimesions(captionIndex))
        // })

        return {
            type: SLIDE.CHANGE_CAPTION_FONT_SIZE,
            payload: { captionSelectedArray, newVal, viewType, diffVal }
        }
    },

    changeCaptionLineHeight(captionSelectedArray, newVal) {
        const viewType = store.getState().menuReducer.viewType;
        let diffVal = null;
        if (captionSelectedArray.length > 1) {
            const editedCaptionIndex = store.getState().menuReducer.editingCaptionIndex;
            const editetCaptionCurrentLineHeight = store.getState().slideReducer.captions[editedCaptionIndex].lineHeight;
            diffVal = newVal - editetCaptionCurrentLineHeight
        }
        return {
            type: SLIDE.CHANGE_CAPTION_LINE_HEIGHT,
            payload: { captionSelectedArray, newVal, viewType, diffVal }
        }
    },
    changeCaptionLetterSpacing(captionSelectedArray, newVal) {
        const viewType = store.getState().menuReducer.viewType;
        let diffVal = null;
        if (captionSelectedArray.length > 1) {
            const editedCaptionIndex = store.getState().menuReducer.editingCaptionIndex;
            const editetCaptionCurrentLetterSpacing = store.getState().slideReducer.captions[editedCaptionIndex].letterSpacing || 0;
            diffVal = newVal - editetCaptionCurrentLetterSpacing
        }
        return {
            type: SLIDE.CHANGE_CAPTION_LETTER_SPACING,
            payload: { captionSelectedArray, newVal, viewType, diffVal }
        }
    },
    changeLetterCase(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_LETTER_CASE,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeCaptionItalic(captionSelectedArray) {
        return {
            type: SLIDE.CHANGE_CAPTION_ITALIC,
            payload: captionSelectedArray
        }
    },

    changeCaptionBold(captionSelectedArray) {
        return {
            type: SLIDE.CHANGE_CAPTION_BOLD,
            payload: captionSelectedArray
        }
    },

    changeCaptionUnderline(captionSelectedArray) {
        return {
            type: SLIDE.CHANGE_CAPTION_UNDERLINE,
            payload: captionSelectedArray
        }
    },

    changeCaptionStrikethrough(captionSelectedArray) {
        return {
            type: SLIDE.CHANGE_CAPTION_STRIKETHROUGH,
            payload: captionSelectedArray
        }
    },

    changeCaptionHasShadow(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_CAPTION_HAS_SHADOW,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeCaptionShadow(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_CAPTION_SHADOW,
            payload: { captionSelectedArray, newVal }
        }
    },

    changeButtonTextHasShadow(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_BUTTON_TEXT_HAS_SHADOW,
            payload: { captionSelectedArray, newVal }
        }
    },
    changeButtonTextShadow(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_BUTTON_TEXT_SHADOW,
            payload: { captionSelectedArray, newVal }
        }
    },
    rotateCaption(captionSelectedArray, newVal) {
        return {
            type: SLIDE.ROTATE_CAPTION,
            payload: { captionSelectedArray, newVal }
        }
    },
    toggleRTL(captionSelectedArray, newVal) {
        return {
            type: SLIDE.TOGGLE_RTL,
            payload: { captionSelectedArray, newVal }
        }
    },
    changeCaptionShape(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_CAPTION_SHAPE,
            payload: { captionSelectedArray, newVal }
        }
    },
    changeCaptionTypewriterCursor(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_CAPTION_TYPEWRITER_CURSOR,
            payload: { captionSelectedArray, value: newVal }
        }
    },

    changeCaptionSEOText(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_CAPTION_SEO_TEXT,
            payload: { captionSelectedArray, value: newVal }
        }
    },
    //=============================!!!Action and history!!!===========================

    addAction() {
        return {
            type: SLIDE.ADD_ACTION
        }
    },

    clearActionsHistory() {
        return {
            type: SLIDE.CLEAR_ACTIONS_HISTORY
        }
    },

    undo() {
        // const actionIndex = store.getState().slideReducer.actionIndex
        const editingText = store.getState().menuReducer.editingText;
        // store.dispatch(menuActions.clearSelectedCaption())
        if (editingText) {
            store.dispatch(menuActions.switchEditingTextPanel(false))
        }
        store.dispatch(menuActions.updateWorkspaceRandom())
        return {
            type: SLIDE.UNDO
        }
    },

    redo() {
        // const actionsLength = store.getState().slideReducer.actions.length
        const editingText = store.getState().menuReducer.editingText;
        // store.dispatch(menuActions.clearSelectedCaption())
        if (editingText) {
            store.dispatch(menuActions.switchEditingTextPanel(false))
        }
        store.dispatch(menuActions.updateWorkspaceRandom())
        return {
            type: SLIDE.REDO
        }
    },

    //=============================!!!Order, alighn and layer!!!===========================

    orderBackward(captions, captionIndex) {
        return {
            type: SLIDE.CHANGE_CAPTION_ORDER,
            payload: arrayMove(captions, captionIndex, captionIndex - 1)
        }
    },

    orderForward(captions, captionIndex) {
        return {
            type: SLIDE.CHANGE_CAPTION_ORDER,
            payload: arrayMove(captions, captionIndex, captionIndex + 1)
        }
    },

    changeCaptionsOrder(newOrder) {
        return {
            type: SLIDE.CHANGE_CAPTION_ORDER,
            payload: newOrder
        }
    },

    changeLayer(captionSelectedArray, actionType) {
        return {
            type: SLIDE.CHANGE_LAYER,
            payload: { captionSelectedArray, actionType }
        }
    },

    changeCaptionMobileShow(captionSelectedArray, newVal) {
        return {
            type: SLIDE.CHANGE_CAPTION_MOBILE_SHOW,
            payload: { captionSelectedArray, newVal }
        }
    },

    toggleCaptionHide(captionSelectedArray, newVal, isMobile) {
        return {
            type: SLIDE.TOGGLE_CAPTION_HIDE,
            payload: { captionSelectedArray, newVal, isMobile }
        }
    },

    deleteToast(toastIndex) {
        return {
            type: SLIDE.DELETE_TOAST,
            payload: toastIndex
        }
    },

    convertBoxPointPosition(boxIndex, newVal, oldVal) {
        let newScale = {
            x: (newVal.width) / oldVal.width,
            y: (newVal.height) / oldVal.height,
        }
        return {
            type: SLIDE.CONVERT_BOX_POINT_POSITION,
            payload: { boxIndex, newScale }
        }
    },

    alignToLeft(captionSelectedArray, deviceType) {
        let minX = 10000;
        const captions = _.cloneDeep(store.getState().slideReducer.captions)
        let positionProperty, x, alignInBox;
        let newPositions = new Map()
        const widgetData = store.getState().slideReducer.widgetData
        const isMobile = deviceType === 'mobile'
        const desktopDims = { width: widgetData.width, height: widgetData.height }
        const mobileDims = { width: widgetData.mobileWidth, height: widgetData.mobileHeight }
        alignInBox = captions[captionSelectedArray[0]].boxId != ''
            &&
            captionSelectedArray.every((selectedIndex) => captions[selectedIndex].boxId === captions[captionSelectedArray[0]].boxId)

        if (alignInBox) {
            x = 'relativeX'
        } else {
            x = 'x'
        }
        switch (deviceType) {
            case 'desktop':
                positionProperty = 'position'
                break;

            case 'mobile':
                positionProperty = 'mobilePosition'
                break;
        }

        if (captionSelectedArray.length === 1) {
            const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[captionSelectedArray[0]])

            newPositions.set(captionSelectedArray[0], captionPosition)
            minX = 0
        } else {
            captionSelectedArray.map((index) => {
                if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                    const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[index])
                    newPositions.set(index, captionPosition)
                    if (captionPosition[x] < minX) {
                        minX = captionPosition[x]
                    }
                }
            })
        }
        captionSelectedArray.map((index) => {
            if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                newPositions.get(index)[x] = minX + captionOuterlineSize
            }
        })


        return {
            type: SLIDE.CHANGE_CAPTION_ALIGN,
            payload: { captionSelectedArray, newPositions, deviceType }
        }
    },

    alignToRight(captionSelectedArray, deviceType) {
        const captions = _.cloneDeep(store.getState().slideReducer.captions)
        const widgetDimasion = store.getState().slideReducer.widgetData
        let maxX = 0;
        let newPositions = new Map()
        let x, alignInBox;

        const isMobile = deviceType === 'mobile'
        const desktopDims = { width: widgetDimasion.width, height: widgetDimasion.height }
        const mobileDims = { width: widgetDimasion.mobileWidth, height: widgetDimasion.mobileHeight }
        let positionProperty = isMobile ? 'mobilePosition' : 'position'
        let heightProperty = isMobile ? 'mobileHeight' : 'height'
        let widthProperty = isMobile ? 'mobileWidth' : 'width'
        // учитываем увеличение лупой в мобильном виде
        const mobileViewScale = store.getState().menuReducer.mobileViewScale / 100

        const workspaceElement = document.querySelector('#workspace')
        // обновляем размеры элемента, особенно высоты касается
        for (let i = 0; i < captions.length; i++) {
            // если перебираемого элемента нет в списке выбранных - переходим к следующему
            if (!captionSelectedArray.some(index => index === captions[i].index)) continue
            const captionElement = workspaceElement.querySelector(`#caption-${captions[i].index}`)
            if (captionElement) {
                const dimensions = captionElement.getBoundingClientRect()
                captions[i][heightProperty] = dimensions.height / mobileViewScale
                captions[i][widthProperty] = dimensions.width / mobileViewScale
            }
        }

        alignInBox = captions[captionSelectedArray[0]].boxId != ''
            &&
            captionSelectedArray.every((selectedIndex) => captions[selectedIndex].boxId === captions[captionSelectedArray[0]].boxId)

        if (alignInBox) {
            x = 'relativeX'
        } else {
            x = 'x'
        }

        if (captionSelectedArray.length === 1) {
            const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[captionSelectedArray[0]])

            newPositions.set(captionSelectedArray[0], captionPosition[positionProperty])
            if (alignInBox) {
                const boxIndex = _.findIndex(captions, { id: captionPosition.boxId })
                const boxWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[boxIndex])

                maxX = boxWidth
            } else {
                maxX = widgetDimasion[widthProperty]
            }
        } else {
            captionSelectedArray.map((index) => {
                if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                    const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[index])
                    const captionWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[index])

                    newPositions.set(index, captionPosition)

                    if (captionPosition[x] + captionWidth > maxX) {
                        maxX = captionPosition[x] + captionWidth
                    }
                }
            })
        }
        captionSelectedArray.map((index) => {
            if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                const captionWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[index])

                newPositions.get(index)[x] = maxX - captionWidth - captionOuterlineSize
            }
        })

        return {
            type: SLIDE.CHANGE_CAPTION_ALIGN,
            payload: { captionSelectedArray, newPositions, deviceType }
        }
    },

    alignToCenter(captionSelectedArray, deviceType) {
        const captions = _.cloneDeep(store.getState().slideReducer.captions)
        const widgetDimasion = store.getState().slideReducer.widgetData
        let newPositions = new Map()
        let minX = 10000;
        let maxX = 0;
        let middleX;
        let x, alignInBox;

        const isMobile = deviceType === 'mobile'
        const desktopDims = { width: widgetDimasion.width, height: widgetDimasion.height }
        const mobileDims = { width: widgetDimasion.mobileWidth, height: widgetDimasion.mobileHeight }
        let positionProperty = isMobile ? 'mobilePosition' : 'position'
        let heightProperty = isMobile ? 'mobileHeight' : 'height'
        let widthProperty = isMobile ? 'mobileWidth' : 'width'
        // учитываем увеличение лупой в мобильном виде
        const mobileViewScale = store.getState().menuReducer.mobileViewScale / 100

        const workspaceElement = document.querySelector('#workspace')
        // обновляем размеры элемента, особенно высоты касается
        for (let i = 0; i < captions.length; i++) {
            // если перебираемого элемента нет в списке выбранных - переходим к следующему
            if (!captionSelectedArray.some(index => index === captions[i].index)) continue
            const captionElement = workspaceElement.querySelector(`#caption-${captions[i].index}`)
            if (captionElement) {
                const dimensions = captionElement.getBoundingClientRect()
                captions[i][heightProperty] = dimensions.height / mobileViewScale
                captions[i][widthProperty] = dimensions.width / mobileViewScale
            }
        }

        alignInBox = captions[captionSelectedArray[0]].boxId != ''
            &&
            captionSelectedArray.every((selectedIndex) => captions[selectedIndex].boxId === captions[captionSelectedArray[0]].boxId)

        if (alignInBox) {
            x = 'relativeX'
        } else {
            x = 'x'
        }

        if (captionSelectedArray.length === 1) {
            const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[captionSelectedArray[0]])

            newPositions.set(captionSelectedArray[0], captionPosition)
            minX = 0
            if (alignInBox) {
                const boxIndex = _.findIndex(captions, { id: captions[captionSelectedArray[0]].boxId })
                const boxWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[boxIndex])

                maxX = boxWidth
            } else {
                maxX = widgetDimasion[widthProperty]
            }
        } else {
            captionSelectedArray.map((index) => {
                if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                    const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[index])
                    const captionWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[index])
                    newPositions.set(index, captionPosition)
                    if (captionPosition[x] < minX) {
                        minX = captionPosition[x]
                    }

                    if (captionPosition[x] + captionWidth > maxX) {
                        maxX = captionPosition[x] + captionWidth
                    }
                }
            })
        }
        captionSelectedArray.map((index) => {
            if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                const captionWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[index])

                middleX = (maxX - minX) / 2 + minX - captionWidth / 2
                newPositions.get(index)[x] = middleX
            }
        })

        return {
            type: SLIDE.CHANGE_CAPTION_ALIGN,
            payload: { captionSelectedArray, newPositions, deviceType }
        }
    },

    alignToTop(captionSelectedArray, deviceType) {
        const captions = _.cloneDeep(store.getState().slideReducer.captions)
        let newPositions = new Map()
        let minY = 10000;
        let positionProperty, y, alignInBox;
        const widgetData = store.getState().slideReducer.widgetData
        const isMobile = deviceType === 'mobile'
        const desktopDims = { width: widgetData.width, height: widgetData.height }
        const mobileDims = { width: widgetData.mobileWidth, height: widgetData.mobileHeight }
        alignInBox = captions[captionSelectedArray[0]].boxId != ''
            &&
            captionSelectedArray.every((selectedIndex) => captions[selectedIndex].boxId === captions[captionSelectedArray[0]].boxId)

        if (alignInBox) {
            y = 'relativeY'
        } else {
            y = 'y'
        }
        switch (deviceType) {
            case 'desktop':
                positionProperty = 'position'
                break;

            case 'mobile':
                positionProperty = 'mobilePosition'
                break;
        }

        if (captionSelectedArray.length === 1) {
            const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[captionSelectedArray[0]])

            newPositions.set(captionSelectedArray[0], captionPosition)
            minY = 0
        } else {
            captionSelectedArray.map((index) => {
                if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                    const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[index])

                    newPositions.set(index, captionPosition)
                    if (captionPosition[y] < minY) {
                        minY = captionPosition[y]
                    }
                }
            })
        }
        captionSelectedArray.map((index) => {
            if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                newPositions.get(index)[y] = minY + captionOuterlineSize
            }
        })

        return {
            type: SLIDE.CHANGE_CAPTION_ALIGN,
            payload: { captionSelectedArray, newPositions, deviceType }
        }
    },

    alignToBottom(captionSelectedArray, deviceType) {
        const captions = _.cloneDeep(store.getState().slideReducer.captions)

        const isMobile = deviceType === 'mobile'
        let positionProperty = isMobile ? 'mobilePosition' : 'position'
        let heightProperty = isMobile ? 'mobileHeight' : 'height'
        let widthProperty = isMobile ? 'mobileWidth' : 'width'
        // учитываем увеличение лупой в мобильном виде
        const mobileViewScale = store.getState().menuReducer.mobileViewScale / 100

        const workspaceElement = document.querySelector('#workspace')
        // обновляем размеры элемента, особенно высоты касается
        for (let i = 0; i < captions.length; i++) {
            // если перебираемого элемента нет в списке выбранных - переходим к следующему
            if (!captionSelectedArray.some(index => index === captions[i].index)) continue
            const captionElement = workspaceElement.querySelector(`#caption-${captions[i].index}`)
            if (captionElement) {
                const dimensions = captionElement.getBoundingClientRect()
                captions[i][heightProperty] = dimensions.height / mobileViewScale
                captions[i][widthProperty] = dimensions.width / mobileViewScale
            }
        }

        const widgetDimasion = store.getState().slideReducer.widgetData
        const desktopDims = { width: widgetDimasion.width, height: widgetDimasion.height }
        const mobileDims = { width: widgetDimasion.mobileWidth, height: widgetDimasion.mobileHeight }
        let newPositions = new Map()
        let maxY = 0;
        let y, alignInBox;

        alignInBox = captions[captionSelectedArray[0]].boxId != ''
            &&
            captionSelectedArray.every((selectedIndex) => captions[selectedIndex].boxId === captions[captionSelectedArray[0]].boxId)

        if (alignInBox) {
            y = 'relativeY'
        } else {
            y = 'y'
        }

        if (captionSelectedArray.length === 1) {
            const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[captionSelectedArray[0]])

            newPositions.set(captionSelectedArray[0], captionPosition)
            if (alignInBox) {
                const boxIndex = _.findIndex(captions, { id: captions[captionSelectedArray[0]].boxId })
                const boxHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[boxIndex])

                maxY = boxHeight
            } else {
                maxY = widgetDimasion[heightProperty]
            }
        } else {
            // находим максимальное значение
            captionSelectedArray.map((index) => {
                if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                    const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[index])
                    const captionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[index])

                    newPositions.set(index, captionPosition)

                    if (captionPosition[y] + captionHeight > maxY) {
                        maxY = captionPosition[y] + captionHeight
                    }
                }
            })
        }
        captionSelectedArray.map((index) => {
            if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                const captionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[index])

                // выравниваем все одинаково
                newPositions.get(index)[y] = maxY - captionHeight - captionOuterlineSize
            }
        })


        return {
            type: SLIDE.CHANGE_CAPTION_ALIGN,
            payload: { captionSelectedArray, newPositions, deviceType }
        }
    },

    alignToMiddle(captionSelectedArray, deviceType) {
        const captions = _.cloneDeep(store.getState().slideReducer.captions)

        const isMobile = deviceType === 'mobile'
        let positionProperty = isMobile ? 'mobilePosition' : 'position'
        let heightProperty = isMobile ? 'mobileHeight' : 'height'
        let widthProperty = isMobile ? 'mobileWidth' : 'width'
        // учитываем увеличение лупой в мобильном виде
        const mobileViewScale = store.getState().menuReducer.mobileViewScale / 100

        // обновляем размеры элемента, особенно высоты касается
        const workspaceElement = document.querySelector('#workspace')
        for (let i = 0; i < captions.length; i++) {
            // если перебираемого элемента нет в списке выбранных - переходим к следующему
            if (!captionSelectedArray.some(index => index === captions[i].index)) continue
            const captionElement = workspaceElement.querySelector(`#caption-${captions[i].index}`)
            if (captionElement) {
                const dimensions = captionElement.getBoundingClientRect()
                captions[i][heightProperty] = dimensions.height / mobileViewScale
                captions[i][widthProperty] = dimensions.width / mobileViewScale
            }
        }

        const widgetDimasion = store.getState().slideReducer.widgetData
        const desktopDims = { width: widgetDimasion.width, height: widgetDimasion.height }
        const mobileDims = { width: widgetDimasion.mobileWidth, height: widgetDimasion.mobileHeight }
        let newPositions = new Map()
        let minY = 10000;
        let maxY = 0;
        let middleY;
        let y, alignInBox;

        alignInBox = captions[captionSelectedArray[0]].boxId != ''
            &&
            captionSelectedArray.every((selectedIndex) => captions[selectedIndex].boxId === captions[captionSelectedArray[0]].boxId)

        if (alignInBox) {
            y = 'relativeY'
        } else {
            y = 'y'
        }

        if (captionSelectedArray.length === 1) {
            const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[captionSelectedArray[0]])

            newPositions.set(captionSelectedArray[0], captionPosition)
            minY = 0
            if (alignInBox) {
                const boxIndex = _.findIndex(captions, { id: captions[captionSelectedArray[0]].boxId })
                const boxHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[boxIndex])

                maxY = boxHeight
            } else {
                maxY = widgetDimasion[heightProperty]
            }
        } else {
            captionSelectedArray.map((index) => {
                if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                    const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[index])
                    const captionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[index])
                    newPositions.set(index, captionPosition)

                    if (captionPosition[y] < minY) {
                        minY = captionPosition[y]
                    }

                    if (captionPosition[y] + captionHeight > maxY) {
                        maxY = captionPosition[y] + captionHeight
                    }
                }
            })
        }
        captionSelectedArray.map((index) => {
            if ((alignInBox && captions[index].boxId === captions[captionSelectedArray[0]].boxId) || (!alignInBox && captions[index].boxId === '')) {
                const captionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[index])

                middleY = (maxY - minY) / 2 + minY - captionHeight / 2
                newPositions.get(index)[y] = middleY
            }
        })


        return {
            type: SLIDE.CHANGE_CAPTION_ALIGN,
            payload: { captionSelectedArray, newPositions, deviceType }
        }
    },

    distributeCaptionsVertically(captionSelectedArray, deviceType) {
        const captions = _.cloneDeep(store.getState().slideReducer.captions)
        let minY = 9999;
        let minX = 9999;
        let maxY = 0;
        let maxX = 0;
        let middleX = 0;
        let step = 0;
        let space = 0;
        let prevCaptionIndex = -1;
        let newPositions = new Map()

        const isMobile = deviceType === 'mobile'
        const widgetDimasion = store.getState().slideReducer.widgetData
        const desktopDims = { width: widgetDimasion.width, height: widgetDimasion.height }
        const mobileDims = { width: widgetDimasion.mobileWidth, height: widgetDimasion.mobileHeight }
        let positionProp = isMobile ? 'mobilePosition' : 'position'
        let heightProp = isMobile ? 'mobileHeight' : 'height'
        let widthProp = isMobile ? 'mobileWidth' : 'width'
        // учитываем увеличение лупой в мобильном виде
        const mobileViewScale = store.getState().menuReducer.mobileViewScale / 100

        const alignInBox = captions[captionSelectedArray[0]].boxId != ''
            &&
            captionSelectedArray.every((selectedIndex) => captions[selectedIndex].boxId === captions[captionSelectedArray[0]].boxId)

        let xProp, yProp
        if (alignInBox) {
            xProp = 'relativeX'
            yProp = 'relativeY'
        } else {
            xProp = 'x'
            yProp = 'y'
        }

        const workspaceElement = document.querySelector('#workspace')
        // обновляем размеры элемента, особенно высоты касается
        for (let i = 0; i < captions.length; i++) {
            // если перебираемого элемента нет в списке выбранных - переходим к следующему
            if (!captionSelectedArray.some(index => index === captions[i].index)) continue
            const captionElement = workspaceElement.querySelector(`#caption-${captions[i].index}`)
            if (captionElement) {
                const dimensions = captionElement.getBoundingClientRect()
                captions[i][heightProp] = dimensions.height / mobileViewScale
                captions[i][widthProp] = dimensions.width / mobileViewScale
            }
        }

        captionSelectedArray.map((index) => {
            // if (captions[index].boxId === '') {
            const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[index])
            const captionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[index])
            const captionWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[index])

            newPositions.set(index, captionPosition)
            if (captionPosition[yProp] < minY) {
                minY = captionPosition[yProp]
            }

            if (captionPosition[yProp] + captionHeight > maxY) {
                maxY = captionPosition[yProp] + captionHeight
            }

            if (captionPosition[xProp] < minX) {
                minX = captionPosition[xProp]
            }

            if (captionPosition[xProp] + captionWidth > maxX) {
                maxX = captionPosition[xProp] + captionWidth
            }
            // }
        })

        //greate match
        middleX = (maxX - minX) / 2 + minX
        space = maxY - minY
        captionSelectedArray.map((index, indexInSelectedArray) => {
            const captionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[index])

            space -= captionHeight
        })
        step = space / (captionSelectedArray.length - 1)
        captionSelectedArray = captionSelectedArray.sort((nextIndex, prevIndex) => {
            const firstCaptionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[prevIndex])
            const secondCaptionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[nextIndex])
            if (firstCaptionPosition[yProp] < secondCaptionPosition[yProp]) {
                return 1
            } else {
                return -1
            }
        })
        captionSelectedArray.map((index, indexInSelectedArray) => {
            let prevCaptionY = prevCaptionIndex > -1 ? newPositions.get(captionSelectedArray[prevCaptionIndex])[yProp] + captions[captionSelectedArray[prevCaptionIndex]][heightProp] : 0
            // if (captions[index].boxId === '') {
            const captionWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[index])
            newPositions.get(index)[xProp] = middleX - captionWidth / 2
            newPositions.get(index)[yProp] = prevCaptionIndex < 0 ? minY : prevCaptionY + step
            prevCaptionIndex++;
            // }
        })


        // switch (deviceType) {
        //     case 'desktop':
        //         //search min ans max


        //         captionSelectedArray.map((index) => {
        //             if (captions[index].boxId === '') {
        //                 newPositions.set(index, captions[index].position)
        //                 if (captions[index].position.y < minY) {
        //                     minY = captions[index].position.y
        //                 }

        //                 if (captions[index].position.y + captions[index].height > maxY) {
        //                     maxY = captions[index].position.y + captions[index].height
        //                 }

        //                 if (captions[index].position.x < minX) {
        //                     minX = captions[index].position.x
        //                 }

        //                 if (captions[index].position.x + captions[index].width > maxX) {
        //                     maxX = captions[index].position.x + captions[index].width
        //                 }
        //             }
        //         })

        //         //greate match
        //         middleX = (maxX - minX) / 2 + minX
        //         space = maxY - minY
        //         captionSelectedArray.map((index, indexInSelectedArray) => {
        //             space -= captions[index].height
        //         })
        //         step = space / (captionSelectedArray.length - 1)
        //         captionSelectedArray = captionSelectedArray.sort((nextIndex, prevIndex) => {
        //             if (captions[prevIndex].position.y < captions[nextIndex].position.y) {
        //                 return 1
        //             } else {
        //                 return -1
        //             }
        //         })
        //         captionSelectedArray.map((index, indexInSelectedArray) => {
        //             let prevCaptionY = prevCaptionIndex > -1 ? newPositions.get(captionSelectedArray[prevCaptionIndex]).y + captions[captionSelectedArray[prevCaptionIndex]].height : 0
        //             if (captions[index].boxId === '') {
        //                 newPositions.get(index).x = middleX - captions[index].width / 2
        //                 newPositions.get(index).y = prevCaptionIndex < 0 ? minY : prevCaptionY + step
        //                 prevCaptionIndex++;
        //             }
        //         })
        //         break;

        //     case 'mobile':
        //         //search min ans max
        //         captionSelectedArray.map(index => {
        //             if (captions[index].boxId === '') {
        //                 newPositions.set(index, captions[index].mobilePosition)

        //                 if (captions[index].mobilePosition.y < minY) {
        //                     minY = captions[index].mobilePosition.y
        //                 }

        //                 if (captions[index].mobilePosition.y + captions[index].mobileHeight > maxY) {
        //                     maxY = captions[index].mobilePosition.y + captions[index].mobileHeight
        //                 }

        //                 if (captions[index].mobilePosition.x < minX) {
        //                     minX = captions[index].mobilePosition.x
        //                 }

        //                 if (captions[index].mobilePosition.x + captions[index].mobileWidth > maxX) {
        //                     maxX = captions[index].mobilePosition.x + captions[index].mobileWidth
        //                 }
        //             }
        //         })

        //         //greate match
        //         middleX = (maxX - minX) / 2 + minX
        //         space = maxY - minY
        //         captionSelectedArray.map((index, indexInSelectedArray) => {
        //             space -= captions[index].mobileHeight
        //         })
        //         step = space / (captionSelectedArray.length - 1)
        //         captionSelectedArray = captionSelectedArray.sort((nextIndex, prevIndex) => {
        //             if (captions[prevIndex].mobilePosition.y < captions[nextIndex].mobilePosition.y) {
        //                 return 1
        //             } else {
        //                 return -1
        //             }
        //         })

        //         captionSelectedArray.map((index, indexInSelectedArray) => {
        //             let prevCaptionY = prevCaptionIndex > -1 ? newPositions.get(captionSelectedArray[prevCaptionIndex]).y + captions[captionSelectedArray[prevCaptionIndex]].mobileHeight : 0
        //             if (captions[index].boxId === '') {
        //                 newPositions.get(index).x = middleX - captions[index].mobileWidth / 2
        //                 newPositions.get(index).y = prevCaptionIndex < 0 ? minY : prevCaptionY + step
        //                 prevCaptionIndex++;
        //             }
        //         })
        //         break;

        // }

        return {
            type: SLIDE.CHANGE_CAPTION_ALIGN,
            payload: { captionSelectedArray, newPositions, deviceType }
        }
    },

    distributeCaptionsHorizontally(captionSelectedArray, deviceType) {
        const captions = _.cloneDeep(store.getState().slideReducer.captions)
        let minY = 9999;
        let minX = 9999;
        let maxY = 0;
        let maxX = 0;
        let middleY = 0;
        let step = 0;
        let newPositions = new Map();
        let prevCaptionIndex = -1;
        let space = 0;

        // let maxCenterX = null;
        // let maxCenterY = null;
        // let minCenterX = null;
        // let minCenterY = null;

        const isMobile = deviceType === 'mobile'
        const widgetDimasion = store.getState().slideReducer.widgetData
        const desktopDims = { width: widgetDimasion.width, height: widgetDimasion.height }
        const mobileDims = { width: widgetDimasion.mobileWidth, height: widgetDimasion.mobileHeight }
        let positionProp = isMobile ? 'mobilePosition' : 'position'
        let heightProp = isMobile ? 'mobileHeight' : 'height'
        let widthProp = isMobile ? 'mobileWidth' : 'width'
        // учитываем увеличение лупой в мобильном виде
        const mobileViewScale = isMobile ? store.getState().menuReducer.mobileViewScale / 100 : 1

        const alignInBox = captions[captionSelectedArray[0]].boxId != ''
            &&
            captionSelectedArray.every((selectedIndex) => captions[selectedIndex].boxId === captions[captionSelectedArray[0]].boxId)

        let xProp, yProp
        if (alignInBox) {
            xProp = 'relativeX'
            yProp = 'relativeY'
        } else {
            xProp = 'x'
            yProp = 'y'
        }

        const workspaceElement = document.querySelector('#workspace')
        // обновляем размеры элемента, особенно высоты касается
        for (let i = 0; i < captions.length; i++) {
            // если перебираемого элемента нет в списке выбранных - переходим к следующему
            if (!captionSelectedArray.some(index => index === captions[i].index)) continue
            const captionElement = workspaceElement.querySelector(`#caption-${captions[i].index}`)
            if (captionElement) {
                const dimensions = captionElement.getBoundingClientRect()
                captions[i][heightProp] = dimensions.height / mobileViewScale
                captions[i][widthProp] = dimensions.width / mobileViewScale
            }
        }

        //search min ans max
        captionSelectedArray.map((index) => {
            // if (captions[index].boxId === '') {
            const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[index])
            const captionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[index])
            const captionWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[index])
            newPositions.set(index, captionPosition)

            if (captionPosition[yProp] < minY) {
                minY = captionPosition[yProp]
            }

            if (captionPosition[yProp] + captionHeight > maxY) {
                maxY = captionPosition[yProp] + captionHeight
            }

            if (captionPosition[xProp] < minX) {
                minX = captionPosition[xProp]
            }

            if (captionPosition[xProp] + captionWidth > maxX) {
                maxX = captionPosition[xProp] + captionWidth
            }
            // }
        })

        //greate match
        middleY = (maxY - minY) / 2 + minY
        space = maxX - minX
        captionSelectedArray.map((index, indexInSelectedArray) => {
            const captionWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[index])

            space -= captionWidth
        })
        step = space / (captionSelectedArray.length - 1)
        captionSelectedArray = captionSelectedArray.sort((nextIndex, prevIndex) => {
            const firstCaptionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[prevIndex])
            const secondCaptionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[nextIndex])
            if (firstCaptionPosition[xProp] < secondCaptionPosition[xProp]) {
                return 1
            } else {
                return -1
            }
        })

        captionSelectedArray.map((index, indexInSelectedArray) => {
            const captionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[index])
            let prevCaptionX = prevCaptionIndex > -1 ? newPositions.get(captionSelectedArray[prevCaptionIndex])[xProp] + captions[captionSelectedArray[prevCaptionIndex]][widthProp] : 0
            // if (captions[index].boxId === '') {
            newPositions.get(index)[yProp] = middleY - captionHeight / 2
            newPositions.get(index)[xProp] = prevCaptionIndex < 0 ? minX : prevCaptionX + step
            prevCaptionIndex++
            // }

        })


        // switch (deviceType) {
        //     case 'desktop':
        //         //search min ans max
        //         captionSelectedArray.map((index) => {
        //             if (captions[index].boxId === '') {
        //                 newPositions.set(index, captions[index].position)

        //                 if (captions[index].position.y < minY) {
        //                     minY = captions[index].position.y
        //                 }

        //                 if (captions[index].position.y + captions[index].height > maxY) {
        //                     maxY = captions[index].position.y + captions[index].height
        //                 }

        //                 if (captions[index].position.x < minX) {
        //                     minX = captions[index].position.x
        //                 }

        //                 if (captions[index].position.x + captions[index].width > maxX) {
        //                     maxX = captions[index].position.x + captions[index].width
        //                 }
        //             }
        //         })

        //         //greate match
        //         middleY = (maxY - minY) / 2 + minY
        //         space = maxX - minX
        //         captionSelectedArray.map((index, indexInSelectedArray) => {
        //             space -= captions[index].width
        //         })
        //         step = space / (captionSelectedArray.length - 1)
        //         captionSelectedArray = captionSelectedArray.sort((nextIndex, prevIndex) => {
        //             if (captions[prevIndex].position.x < captions[nextIndex].position.x) {
        //                 return 1
        //             } else {
        //                 return -1
        //             }
        //         })

        //         captionSelectedArray.map((index, indexInSelectedArray) => {
        //             let prevCaptionX = prevCaptionIndex > -1 ? newPositions.get(captionSelectedArray[prevCaptionIndex]).x + captions[captionSelectedArray[prevCaptionIndex]].width : 0
        //             if (captions[index].boxId === '') {
        //                 newPositions.get(index).y = middleY - captions[index].height / 2
        //                 newPositions.get(index).x = prevCaptionIndex < 0 ? minX : prevCaptionX + step
        //                 prevCaptionIndex++
        //             }

        //         })
        //         break;

        //     case 'mobile':
        //         //search min ans max
        //         captionSelectedArray.map((index) => {
        //             if (captions[index].boxId === '') {
        //                 newPositions.set(index, captions[index].mobilePosition)

        //                 if (captions[index].mobilePosition.y < minY) {
        //                     minY = captions[index].mobilePosition.y
        //                 }

        //                 if (captions[index].mobilePosition.y + captions[index].mobileHeight > maxY) {
        //                     maxY = captions[index].mobilePosition.y + captions[index].mobileHeight
        //                 }

        //                 if (captions[index].mobilePosition.x < minX) {
        //                     minX = captions[index].mobilePosition.x
        //                 }

        //                 if (captions[index].mobilePosition.x + captions[index].mobileWidth > maxX) {
        //                     maxX = captions[index].mobilePosition.x + captions[index].mobileWidth
        //                 }
        //             }
        //         })

        //         //greate match
        //         middleY = (maxY - minY) / 2 + minY
        //         space = maxX - minX
        //         captionSelectedArray.map((index, indexInSelectedArray) => {
        //             space -= captions[index].mobileWidth
        //         })
        //         step = space / (captionSelectedArray.length - 1)
        //         captionSelectedArray = captionSelectedArray.sort((nextIndex, prevIndex) => {
        //             if (captions[prevIndex].mobilePosition.x < captions[nextIndex].mobilePosition.x) {
        //                 return 1
        //             } else {
        //                 return -1
        //             }
        //         })

        //         captionSelectedArray.map((index, indexInSelectedArray) => {
        //             let prevCaptionX = prevCaptionIndex > -1 ? newPositions.get(captionSelectedArray[prevCaptionIndex]).x + captions[captionSelectedArray[prevCaptionIndex]].mobileWidth : 0
        //             if (captions[index].boxId === '') {
        //                 captions[index].mobilePosition.y = middleY - captions[index].mobileHeight / 2
        //                 captions[index].mobilePosition.x = prevCaptionIndex < 0 ? minX : prevCaptionX + step
        //                 prevCaptionIndex++;
        //             }
        //         })
        //         break;

        // }
        return {
            type: SLIDE.CHANGE_CAPTION_ALIGN,
            payload: { captionSelectedArray, newPositions, deviceType }
        }
    },

    distributeCaptions(captionSelectedArray, deviceType) {
        const widgetDimasion = _.cloneDeep(store.getState().slideReducer.widgetData)
        const captions = _.cloneDeep(store.getState().slideReducer.captions)
        let newPositions = new Map()
        // let captionsInDom = new Map()
        let minX = 9999;
        let minY = 9999;
        let maxY = 0;
        let maxX = 0;
        let stepX = 0;
        let stepY = 0;
        let spaceX = 0;
        let spaceY = 0;
        let prevCaptionIndex = -1;
        let isFirst = null;
        let firstXPosition = null;
        let firstYPosition = null;
        let prevCaptionX = null;
        let prevCaptionY = null;
        let isLast = null;
        let lastXPosition = null;
        let lastYPosition = null;
        let fitOnX = null;
        let fitOnY = null;

        let maxCenterX = null;
        let maxCenterY = null;
        let minCenterX = null;
        let minCenterY = null;

        const isMobile = deviceType === 'mobile'
        const desktopDims = { width: widgetDimasion.width, height: widgetDimasion.height }
        const mobileDims = { width: widgetDimasion.mobileWidth, height: widgetDimasion.mobileHeight }
        let positionProp = isMobile ? 'mobilePosition' : 'position'
        let heightProp = isMobile ? 'mobileHeight' : 'height'
        let widthProp = isMobile ? 'mobileWidth' : 'width'
        // учитываем увеличение лупой в мобильном виде
        const mobileViewScale = isMobile ? store.getState().menuReducer.mobileViewScale / 100 : 1

        const alignInBox = captions[captionSelectedArray[0]].boxId != ''
            &&
            captionSelectedArray.every((selectedIndex) => captions[selectedIndex].boxId === captions[captionSelectedArray[0]].boxId)

        let xProp, yProp
        if (alignInBox) {
            xProp = 'relativeX'
            yProp = 'relativeY'
        } else {
            xProp = 'x'
            yProp = 'y'
        }

        const workspaceElement = document.querySelector('#workspace')
        // обновляем размеры элемента, особенно высоты касается
        for (let i = 0; i < captions.length; i++) {
            // если перебираемого элемента нет в списке выбранных - переходим к следующему
            if (!captionSelectedArray.some(index => index === captions[i].index)) continue
            const captionElement = workspaceElement.querySelector(`#caption-${captions[i].index}`)
            if (captionElement) {
                const dimensions = captionElement.getBoundingClientRect()
                captions[i][heightProp] = dimensions.height / mobileViewScale
                captions[i][widthProp] = dimensions.width / mobileViewScale
            }
        }
        // let yProp = 'y'

        // switch (deviceType) {
        //     case 'desktop':
        // //search min and max
        // captionSelectedArray.map((index) => {
        //     if (captions[index].boxId === '') {
        //         newPositions.set(index, captions[index].position)

        //         if (captions[index].position.y + captions[index].height < minY) {
        //             minY = captions[index].position.y + captions[index].height
        //             minX = captions[index].position.x + captions[index].width / 2
        //         }

        //         if (captions[index].position.y > maxY) {
        //             maxY = captions[index].position.y
        //             maxX = captions[index].position.x + captions[index].width / 2
        //         }
        //     }
        // })

        // //sort
        // captionSelectedArray = captionSelectedArray.sort((nextIndex, prevIndex) => {
        //     if (captions[prevIndex].position.y < captions[nextIndex].position.y) {
        //         return 1
        //     } else {
        //         return -1
        //     }
        // })

        // //greate match
        // spaceX = maxX - minX
        // captionSelectedArray.map((index, indexInSelectedArray) => {
        //     if (indexInSelectedArray != 0) {
        //         spaceX -= captions[index].width / 2
        //     }
        // })

        // stepX = spaceX / (captionSelectedArray.length - 1)

        // spaceY = maxY - minY
        // captionSelectedArray.map((index, indexInSelectedArray) => {
        //     if (indexInSelectedArray != 0 && indexInSelectedArray != captionSelectedArray.length - 1) {
        //         spaceY -= captions[index].height
        //     }
        // })
        // stepY = spaceY / (captionSelectedArray.length - 1)



        // //apply new positions
        // captionSelectedArray.map((index, indexInSelectedArray) => {
        //     isFirst = indexInSelectedArray === 0;
        //     firstXPosition = minX - captions[index].width / 2;
        //     firstYPosition = minY - captions[index].height;

        //     prevCaptionX = isFirst ? 0 : newPositions.get(captionSelectedArray[prevCaptionIndex]).x + captions[captionSelectedArray[prevCaptionIndex]].width / 2;
        //     prevCaptionY = isFirst ? 0 : newPositions.get(captionSelectedArray[prevCaptionIndex]).y + captions[captionSelectedArray[prevCaptionIndex]].height;

        //     isLast = false
        //     lastXPosition = isLast ? 0 : maxX - captions[index].width / 2;
        //     lastYPosition = isLast ? 0 : maxY;


        //     fitOnX = stepX + prevCaptionX + captions[index].width < widgetDimasion.width;
        //     fitOnY = stepY + prevCaptionY + captions[index].height < widgetDimasion.height;

        //     if (captions[index].boxId === '') {
        //         if (fitOnX) {
        //             newPositions.get(index).x = isFirst ? firstXPosition : isLast ? lastXPosition : (prevCaptionX + stepX)
        //         } else {
        //             newPositions.get(index).x = widgetDimasion.width - captions[index].width
        //         }

        //         if (fitOnY) {
        //             newPositions.get(index).y = isFirst ? firstYPosition : isLast ? lastYPosition : (stepY + prevCaptionY)
        //         } else {
        //             newPositions.get(index).y = widgetDimasion.height - captions[index].height
        //         }
        //         prevCaptionIndex++;
        //     }
        // })
        //     break;

        // case 'mobile':
        // captionSelectedArray.map((index) => {
        //     if (captions[index].boxId === '') {
        //         newPositions.set(index, captions[index].mobilePosition)

        //         if (captions[index].mobilePosition.y < minY) {
        //             minY = captions[index].mobilePosition.y + captions[index].mobileHeight
        //             minX = captions[index].mobilePosition.x + captions[index].mobileWidth / 2
        //         }

        //         if (captions[index].mobilePosition.y + captions[index].height > maxY) {
        //             maxY = captions[index].mobilePosition.y
        //             maxX = captions[index].mobilePosition.x + captions[index].mobileWidth / 2
        //         }
        //     }
        // })

        // //sort
        // captionSelectedArray = captionSelectedArray.sort((nextIndex, prevIndex) => {
        //     if (captions[prevIndex].mobilePosition.y < captions[nextIndex].mobilePosition.y) {
        //         return 1
        //     } else {
        //         return -1
        //     }
        // })

        // //greate match                
        // spaceX = maxX - minX
        // captionSelectedArray.map((index, indexInSelectedArray) => {
        //     if (indexInSelectedArray != 0) {
        //         spaceX -= captions[index].mobileWidth / 2
        //     }
        // })
        // stepX = spaceX / (captionSelectedArray.length - 1)

        // spaceY = maxY - minY
        // captionSelectedArray.map((index, indexInSelectedArray) => {
        //     if (indexInSelectedArray != 0 && indexInSelectedArray != captionSelectedArray.length - 1) {
        //         spaceY -= captions[index].mobileHeight
        //     }
        // })
        // stepY = spaceY / (captionSelectedArray.length - 1)

        // captionSelectedArray.map((index, indexInSelectedArray) => {
        //     isFirst = indexInSelectedArray === 0;
        //     firstXPosition = minX - captions[index].mobileWidth / 2;
        //     firstYPosition = minY - captions[index].mobileHeight;

        //     prevCaptionX = isFirst ? 0 : newPositions.get(captionSelectedArray[prevCaptionIndex]).x + captions[captionSelectedArray[prevCaptionIndex]].mobileWidth / 2;
        //     prevCaptionY = isFirst ? 0 : newPositions.get(captionSelectedArray[prevCaptionIndex]).y + captions[captionSelectedArray[prevCaptionIndex]].mobileHeight;

        //     isLast = false;
        //     lastXPosition = isLast ? 0 : maxX - captions[index].mobileWidth / 2;
        //     lastYPosition = isLast ? 0 : maxY;


        //     fitOnX = stepX + prevCaptionX + captions[index].mobileWidth < widgetDimasion.mobileWidth;
        //     fitOnY = stepY + prevCaptionY + captions[index].mobileHeight < widgetDimasion.mobileHeight;

        //     if (captions[index].boxId === '') {
        //         if (fitOnX) {
        //             newPositions.get(index).x = isFirst ? firstXPosition : isLast ? lastXPosition : (prevCaptionX + stepX)
        //         } else {
        //             newPositions.get(index).x = widgetDimasion.mobileWidth - captions[index].mobileWidth
        //         }

        //         if (fitOnY) {
        //             newPositions.get(index).y = isFirst ? firstYPosition : isLast ? lastYPosition : (stepY + prevCaptionY)
        //         } else {
        //             newPositions.get(index).y = widgetDimasion.mobileHeight - captions[index].mobileHeight
        //         }
        //         prevCaptionIndex++;
        //     }
        // })
        //         break;

        // }

        captionSelectedArray.map((index) => {
            const captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[index])
            const captionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[index])
            const captionWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[index])
            // if (alignInBox || captions[index].boxId === '') {
            newPositions.set(index, captionPosition)

            if (captionPosition[yProp] + captionHeight / 2 > maxY) {
                // highestCaptionIndex = index
                maxCenterX = captionPosition[xProp] + captionWidth / 2
                maxY = captionPosition[yProp] + captionHeight / 2
                maxCenterY = maxY
            }
            if (captionPosition[yProp] + captionHeight / 2 <= minY) {
                // lowestCaptionIndex = index
                minCenterX = captionPosition[xProp] + captionWidth / 2
                minY = captionPosition[yProp] + captionHeight / 2
                minCenterY = minY
            }
            // }
        })


        //sort
        captionSelectedArray = captionSelectedArray.sort((nextIndex, prevIndex) => {
            const firstCaptionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[prevIndex])
            const firstCaptionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[prevIndex])
            const secondCaptionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, captions[nextIndex])
            const secondCaptionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[nextIndex])
            if (firstCaptionPosition[yProp] + firstCaptionHeight / 2 < secondCaptionPosition[yProp] + secondCaptionHeight / 2) {
                // if (captions[prevIndex].position.y < captions[nextIndex].position.y) {
                return 1
            } else {
                return -1
            }
        })

        const lengthX = maxCenterX - minCenterX
        stepX = lengthX / (captionSelectedArray.length - 1)
        const lengthY = maxCenterY - minCenterY
        stepY = lengthY / (captionSelectedArray.length - 1)


        captionSelectedArray.map((index, indexInSelectedArray) => {
            const captionPosition = newPositions.get(index) || captions[index][positionProp]
            if (indexInSelectedArray > 0) {
                const captionWidth = getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, captions[index])
                const captionHeight = getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, captions[index])

                captionPosition[xProp] = minCenterX - captionWidth / 2 + stepX * indexInSelectedArray
                captionPosition[yProp] = minCenterY - captionHeight / 2 + stepY * indexInSelectedArray
                newPositions.set(index, captionPosition)
            }

        })

        return {
            type: SLIDE.CHANGE_CAPTION_ALIGN,
            payload: { captionSelectedArray, newPositions, deviceType }
        }
    },


    toggleParallax(newVal) {
        return {
            type: SLIDE.TOGGLE_PARALLAX,
            payload: newVal
        }
    },
    changeParallaxImage(newVal) {
        const { currentHeight, currentWidth, currentHeightMobile, currentWidthMobile, data } = newVal
        // currentHeight, currentWidth - текущие размеры виджета на странице
        const parallaxImage = convertParallaxImageStyle(data[0], currentWidth, currentHeight)
        return {
            type: SLIDE.CHANGE_PARALLAX_IMAGE,
            payload: parallaxImage
        }
    },
    applyIParallaxCrop(croppedImage) {
        return {
            type: SLIDE.APPLY_PARALLAX_CROP,
            payload: croppedImage
        }
    },
    toggleSeparateCorners(captionSelectedArray, bool, isMobile) {
        return {
            type: SLIDE.TOGGLE_SEPARATE_CORNERS,
            payload: { captionSelectedArray, bool, isMobile }
        }
    },

    hideShowCaptionsOutside(captionsToHide, captionsToShow) {
        return {
            type: SLIDE.HIDE_SHOW_CAPTIONS_OUTSIDE,
            payload: { captionsToHide, captionsToShow }
        }
    }



}

export { slideActions }